<template>
  <div>
    {{ $vuetify.lang.t('$vuetify.COURSE.BASE_PDF_QUESTION_RENDERRE.LABEL_ANSWER_THE_QUESTION') }}:
    <span v-if="!submission.isQuestionPaper">
      {{ studentAnswer }}
      <span v-if="studentAnswer && !submission.isStudentWork" class="ml-1">
        <span
          :style="{color: isCorrect ? '#4bca81' : '#d4504c', fontWeight: 'bold', fontSize: '14px'}"
          v-html="isCorrect ? '&#10003;' : '&#x2715;'"
        />
      </span>
    </span>
  </div>
</template>
<script>
import get from 'lodash-es/get'
import {mapGetters} from 'vuex'
export default {
  props: {questionId: String},
  computed: {
    ...mapGetters({submission: 'pdfRender/getSubmission'}),
    studentAnswer() {
      const answer = get(this.submission, `answers.${this.questionId}`)
      return get(answer, 'answer', '')
    },
    isCorrect() {
      const answer = get(this.submission, `answers.${this.questionId}`)
      return get(answer, 'isCorrect', false)
    },
  },
}
</script>
